import {Option} from 'platform/components';

export type DictionaryOption = Option & {isDefault: boolean};
